import React from "react";

const ResourceProp = ({ title, data }) => {
  return (
    <div className="bg-white p-6 rounded-[2rem] shadow-sm w-full border border-gray-100 h-full">
      <h2 className="text-xl font-bold text-gray-900 mb-6">{title}</h2>

      <div className="space-y-5">
        {data.map((item, index) => (
          <div key={index} className="flex items-center gap-4">
            {/* Label */}
            <span className="w-24 text-gray-400 text-sm font-medium shrink-0">
              {item.label}
            </span>

            {/* Progress Bar Track */}
            <div className="flex-1 h-2 bg-gray-100 rounded-full overflow-hidden">
              <div
                className="h-full bg-green-700 rounded-full transition-all duration-700"
                style={{ width: typeof item.percent === "number" ? `${item.percent}%` : item.percent }}
              ></div>
            </div>

            {/* Numeric Value / Percentage */}
            <span className="w-16 text-right text-gray-400 text-sm font-medium tabular-nums shrink-0">
              {item.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ResourceProp;
